module.exports = __webpack_public_path__ + "static/img/footerR.50a38329.png";